import {
  getCallsCommandCenterFeed,
} from './CallsCommandCenterFeed';

import {
  GOVERNOR_IDENTITY_REGISTRY,
  GOVERNOR_LIFECYCLE_IDENTIFIERS,
} from '../core';

export type CallsSessionDecision =
  | 'allow'
  | 'block';

export type CallsSessionDecisionReasonCode =
  | 'CALLS_RUNTIME_VERIFIED'
  | 'CALLS_RUNTIME_UNVERIFIED';

export interface CallsSessionDecisionResult {
  readonly governor: string;
  readonly governorId: string;
  readonly governorKey: string;
  readonly domain: string;
  readonly lifecycle: string;
  readonly evidenceSource: 'command-center-feed';
  readonly decision: CallsSessionDecision;
  readonly reasonCode: CallsSessionDecisionReasonCode;
  readonly reason: string;
  readonly evidenceCapturedAt: string;
}

export function evaluateCallsSessionDecision():
CallsSessionDecisionResult {

  const constitutional =
    GOVERNOR_IDENTITY_REGISTRY.CALLS;

  const evidence =
    getCallsCommandCenterFeed();

  const authorized =
    evidence.verified &&
    evidence.status === 'healthy';

  return Object.freeze({
    governor:
      constitutional.governor,

    governorId:
      constitutional.id,

    governorKey:
      constitutional.key,

    domain:
      constitutional.domain,

    lifecycle:
      GOVERNOR_LIFECYCLE_IDENTIFIERS.RUNTIME_DECISION,

    evidenceSource:
      'command-center-feed',

    decision:
      authorized
        ? 'allow'
        : 'block',

    reasonCode:
      authorized
        ? 'CALLS_RUNTIME_VERIFIED'
        : 'CALLS_RUNTIME_UNVERIFIED',

    reason:
      authorized
        ? 'Calls constitutional runtime evidence authorizes this communication session.'
        : 'Calls constitutional runtime evidence blocks this communication session.',

    evidenceCapturedAt:
      evidence.evidenceCapturedAt,
  });
}
